import React from 'react';
import GPAVisualizer from './components/GPAVisualizer';

const App = () => {
  return (
    <div className='container'>
      <GPAVisualizer />
    </div>
  );
};

export default App;
